import { ArrowLeft, Download } from "lucide-react"

import { Spinner } from "./spinner"

interface ReportViewNavbarProps {
  sizeLabel: string
  /** While the PDF is still loading, the size badge shows a spinner. */
  loading: boolean
  onBack: () => void
  onDownload?: () => void
}

/** Top bar: back arrow, centered "Your Report", file-size badge. */
export function ReportViewNavbar({
  sizeLabel,
  loading,
  onBack,
  onDownload,
}: ReportViewNavbarProps) {
  const badge = (
    <>
      {loading ? (
        <Spinner className="size-4 border-purple-light/70" />
      ) : (
        <Download className="size-4 text-purple-light" />
      )}
      {sizeLabel && (
        <span className="font-body text-xs font-semibold text-purple-light">{sizeLabel}</span>
      )}
    </>
  )

  return (
    <div className="relative flex h-14 items-center border-b border-purple-light/10">
      <button
        type="button"
        onClick={onBack}
        aria-label="Back"
        className="absolute left-4 flex size-6 items-center justify-center text-purple-light [&_svg]:size-6"
      >
        <ArrowLeft />
      </button>

      <p className="w-full text-center font-display text-[22px] font-medium leading-[30px] text-purple-light">
        Your Report
      </p>

      {onDownload ? (
        <button
          type="button"
          onClick={onDownload}
          disabled={loading}
          aria-label="Download PDF"
          className="absolute right-4 flex h-8 items-center gap-1 rounded-[20px] bg-main-purple/20 px-3 disabled:opacity-70"
        >
          {badge}
        </button>
      ) : (
        <div className="absolute right-4 flex h-8 items-center gap-1 rounded-[20px] bg-main-purple/20 px-3">
          {badge}
        </div>
      )}
    </div>
  )
}
